  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute, Router } from '@angular/router';
  import { Entities } from 'src/app/core/models/globals';
import { DeploymentService } from 'src/app/core/services/deployment.service';
  import { NavigationService } from 'src/app/core/services/navigation.service';

  @Component({
    selector: 'app-component-navigation',
    templateUrl: './component-navigation.component.html',
    styleUrls: ['./component-navigation.component.scss'],
  })
  export class ComponentNavigationComponent implements OnInit {
    entityName: string;
    entityRouterLink: string;
    activeProperty: string;
    activeDeployment: string;
    cloudType: string;
    lastRefreshedTime: Date; // time when data is loaded/refreshed
    constructor(
      private route: ActivatedRoute,
      private navService: NavigationService,
      private router: Router,
      private deploymentService: DeploymentService
    ) {}

    ngOnInit(): void {
      this.cloudType =
        this.route.snapshot.params['cloudType'] ||
        this.route.parent.snapshot.params['cloudType'];
      this.navService.breadcrumbEntity.subscribe((x) => {
        if (x == Entities.Configurator) {
          this.entityName = x;
        }
        else if (x == Entities.Home) {
          this.entityName = x;
        }
        else {
          this.entityName = x + ' List';
        }
      });
      this.entityRouterLink = '/' + this.entityName;
      this.navService.breadcrumbDeployment.subscribe((x) => {
        this.activeDeployment =
          x ||
          this.route.snapshot.params['deploymentName'] ||
          this.route.parent.snapshot.params['deploymentName'];
        if (!this.activeDeployment) {
          this.activeDeployment =
            this.route.snapshot.params['licenseName'] ||
            this.route.parent.snapshot.params['licenseName'];
        }
      });

      this.navService.breadcrumbActiveProperty.subscribe((x) => {
        // Only update activeProperty if it's relevant to current entity
        if (this.entityName === Entities.Home && x === "Home") {
          this.activeProperty = "Summary";
        } else if (this.entityName === 'Sessions List' && x === "Sessions") {
          this.activeProperty = "";
        } else {
          this.activeProperty = x;
        } 
      });

      this.navService.lastUpdateTime.subscribe((x) => {
        this.lastRefreshedTime = x;
      });
    }

    navigateToEntity() {

      // Navigate to entity list without deployment context
      switch (this.entityName) {
        case 'Home':
          this.router.navigate(['Home']);
          break;
        case 'Configurator':
          this.router.navigate(['Configurator']);
          break;
        case 'Nodes List':
          this.router.navigate(['Nodes List']);
          break;
        case 'Jobs List':
          this.router.navigate(['Jobs List']);
          break;
        case 'Sessions List':
          this.router.navigate(['Session List']);
          break;
        case 'Storages List':
          this.router.navigate(['Storages List']);
          break;
        case 'Licenses List':
          this.router.navigate(['License Servers List']);
          break;
        case 'Applications List':
          this.router.navigate(['Applications List']);
          break;
        default:
          console.warn(`Navigation not configured for entity: ${this.entityName}`);
          break;
      }
    }

    navigateToDeployment(){
      if(this.deploymentService.isDeploymentPresent(this.activeDeployment))
        this.router.navigate(['/Home', this.cloudType, this.activeDeployment, 'summary']);
      else
        this.router.navigate(['/Home']);
    }

    refresh() {
      let url = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([decodeURI(url)]);
      });
    }
  }
